import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Errore", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "album py-5 bg-light" }, [
  /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-center" }, [
    /*#__PURE__*/_createVNode("h5", null, "Pagina non trovata")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_NavBar),
    _hoisted_1,
    _hoisted_2
  ]))
}